module.exports = __webpack_public_path__ + "static/media/jp-splash-photo-left.0974827d.jpg";